/** Polite live region (screen readers): what keyboard navigation just selected. Always mounted, so changes are read. */
export function Announcer({ message }: { message: string }) {
  return (
    <p role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </p>
  );
}
